export default "__VITE_ASSET__DelEKuHO__"